<div class="container">
  <h1>{{ isEdit ? 'Edit' : 'Add New' }} Rider</h1>
  
  <mat-card>
    <mat-card-content>
      <form [formGroup]="riderForm" (ngSubmit)="onSubmit()">
        <!-- Rider Information -->
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Rider Name</mat-label>
            <input matInput type="text" formControlName="name" required>
            <mat-hint>Enter the rider name</mat-hint>
            @if(riderForm.get('name')?.hasError('required')) {
              <mat-error>
                Rider name is required
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Issue Date</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="issue_date" required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-hint>Select the issue date</mat-hint>
            @if(riderForm.get('issue_date')?.hasError('required')) {
              <mat-error>
                Issue date is required
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Face Value</mat-label>
            <input matInput type="text" formControlName="face_value" required numberFormat>
            <span matPrefix>&nbsp;$&nbsp;</span>
            <mat-hint>Enter the rider face value</mat-hint>
            @if(riderForm.get('face_value')?.hasError('required')) {
              <mat-error>
                Rider face value is required
              </mat-error>
            }
            @if(riderForm.get('face_value')?.hasError('min')) {
              <mat-error>
                Rider face value must be positive
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Premium</mat-label>
            <input matInput type="text" formControlName="premium" required numberFormat>
            <span matPrefix>&nbsp;$&nbsp;</span>
            <mat-hint>Enter the premium</mat-hint>
            @if(riderForm.get('premium')?.hasError('required')) {
              <mat-error>
                Premium is required
              </mat-error>
            }
            @if(riderForm.get('premium')?.hasError('min')) {
              <mat-error>
                Premium must be positive
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Cash Value</mat-label>
            <input matInput type="text" formControlName="cash_value" required numberFormat>
            <span matPrefix>&nbsp;$&nbsp;</span>
            <mat-hint>Enter the cash value amount</mat-hint>
            @if(riderForm.get('cash_value')?.hasError('required')) {
              <mat-error>
                Cash value is required
              </mat-error>
            }
            @if(riderForm.get('cash_value')?.hasError('min')) {
              <mat-error>
                Cash value amount must be positive
              </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Create Transaction Option -->
        <div class="form-row">
          <div class="field-container full-width">
            <mat-checkbox formControlName="createTransaction" color="primary">
              Fund from Bank
            </mat-checkbox>
            <div class="checkbox-help-text">
              Check this to fund the rider premium from the selected bank (requires selecting a bank)
            </div>
          </div>
        </div>

        @if(riderForm.get('createTransaction')?.value) {
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Bank Account</mat-label>
              <mat-select formControlName="bank_id">
                @for (bank of banks(); track bank.id) {
                  <mat-option [value]="bank.id">{{ bank.name }}</mat-option>
                }
                @if(banks().length === 0) {
                  <mat-option disabled>
                    No banks found. Please add a bank first.
                  </mat-option>
                }
              </mat-select>
              <mat-hint>Select the bank for this rider</mat-hint>
              @if(riderForm.get('bank_id')?.hasError('required') && riderForm.get('bank_id')?.touched) {
                <mat-error>
                  Bank is required when "Fund from Bank" is checked
                </mat-error>
              }
            </mat-form-field>
          </div>
        }

        <!-- Form Actions -->
        <div class="form-actions">
          <button mat-button type="button" (click)="onCancel()">Cancel</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="!riderForm.valid">
            {{ isEdit ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
